var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgListAccess(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#7ac689"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M11.33 13.87a3.75 3.75 0 1 0-4.157 0 6 6 0 0 0-2.951 2.356.5.5 0 1 0 .837.547 5 5 0 0 1 8.384 0 .5.5 0 0 0 .838-.547 6 6 0 0 0-2.952-2.356M6.5 10.75a2.75 2.75 0 1 1 5.5 0 2.75 2.75 0 0 1-5.5 0m13.134 6.168a.5.5 0 0 1-.692-.145 4.99 4.99 0 0 0-4.192-2.273.5.5 0 1 1 0-1 2.75 2.75 0 1 0-1.021-5.305.5.5 0 1 1-.371-.928 3.75 3.75 0 0 1 3.47 6.603 6 6 0 0 1 2.952 2.356.5.5 0 0 1-.146.692"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListAccess);
export default __webpack_public_path__ + "static/media/list-access.97b19a3ead4dbff3d1cfe92e0da2bc61.svg";
export { ForwardRef as ReactComponent };